import styled from "styled-components";

export const HomePageSC = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 100px;
    
    .primary-widget {
        display: flex;
        height: 600px;
        width: 70vw;
        justify-content: center;
        align-items: center;
        gap: 16px;

        .content-holder {
            width: 40%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 16px;
        }

        .content-title {
            font-size: 72px;
            width: 75%;
            line-height: 82px;
            letter-spacing: 0.7px;
        }

        .hero-image {
            width: 60%;
        }
    }

    .social-icon {
        height: 36px;
        width: 36px;
        cursor: pointer;
    }

    .home-footer {
        margin-top: 56px;
        color: #6b7280;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 16px;
    }

    .home-footer-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 768px) {
        .social-icon {
            height: 24px;
            width: 24px;
        }
    }
`;

export const HomeToolbarSC = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 64px;
    width: 90%;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .brand-name {
        font-size: 28px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 2px;
        color: #000000BB;
    }

    .logo {
        height: 64px;
        width: 64px;
    }

    .side-nav-icon {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }

    .navigation {
        display: flex;
        gap: 12px;
        font-size: 18px;
        text-transform: uppercase;
        letter-spacing: 0.7px;
        gap: 32px;

        span {
            padding: 8px 16px;
            cursor: pointer;
            transition: all 0.15s ease-in-out;

            &:hover {
                font-size: 20px;
            }
        }

        .emergency {
            border: 2px solid #898989;
            border-radius: 16px;
            font-size: 16px;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
        padding: 12px 0px;

        .logo {
            height: 36px;
            width: 36px;
        }

        .brand-name {
            font-size: 22px;
            margin-left: 16px;
        }
    }
`;